import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
//import { Subscription } from '../Classes/SubscriptionClass';
import { CommonSearch } from '../Classes/CommonClass';
import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BackupDatabaseService {
  constructor(private http: Http) { }
  TakeBackup(UserName: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Subscription/TakeBackup?UserName=' + UserName, options).map((res: Response) => res.json());
  }

  RestoreBackup(UserName: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Subscription/RestoreBackup?UserName=' + UserName, options).map((res: Response) => res.json());
  }
  GetDBLogs() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Subscription/GetDBLogs', options).map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/BackupDatabaseService.ts